import script from "./Navigation.vue?vue&type=script&setup=true&lang=js"
export * from "./Navigation.vue?vue&type=script&setup=true&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=5671d733&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5671d733"]])

export default __exports__